import { Box, Image, Text, chakra } from '@chakra-ui/react';
import React from 'react';

import { route } from 'nextjs-routes';

interface Props {
  isCollapsed?: boolean;
  onClick?: (event: React.SyntheticEvent) => void;
  className?: string;
}

const NetworkLogo = ({ isCollapsed, onClick, className }: Props) => {

  return (
    <Box
      className={ className }
      as="a"
      href={ route({ pathname: '/' }) }
      width={{ base: '168px', lg: isCollapsed === false ? '168px' : '58px', xl: isCollapsed ? '58px' : '168px' }}
      minWidth={{ base: '168px', lg: isCollapsed === false ? '168px' : '58px', xl: isCollapsed ? '58px' : '168px' }}
      height={{ base: '46px', lg: '46px' }}
      display="inline-flex"
      alignItems="center"
      gap={{ base: 2, lg: isCollapsed === false ? 2 : 1, xl: isCollapsed ? 1 : 2 }}
      overflow="visible"
      onClick={ onClick }
      flexShrink={ 0 }
      aria-label="Link to main page"
      transitionProperty="common"
      transitionDuration="normal"
      border="1px solid"
      borderColor="rgba(255, 185, 54, 0.18)"
      borderRadius="16px"
      bg="linear-gradient(135deg, rgba(255,255,255,0.08), rgba(255,185,54,0.04))"
      boxShadow="0 0 28px rgba(255, 122, 26, 0.18), inset 0 1px 0 rgba(255,255,255,0.12)"
      px={{ base: 2, lg: isCollapsed === false ? 2 : '6px', xl: isCollapsed ? '6px' : 2 }}
      _hover={{
        transform: 'translateY(-1px)',
        filter: 'drop-shadow(0 0 18px rgba(255, 185, 54, 0.42))',
        borderColor: 'rgba(255, 185, 54, 0.42)',
      }}
    >
      <Image
        src="/assets/elvor-symbol.png"
        alt="Elvor logo"
        boxSize={{ base: '34px', lg: isCollapsed === false ? '34px' : '30px', xl: isCollapsed ? '30px' : '34px' }}
        objectFit="contain"
        flexShrink={ 0 }
        filter="drop-shadow(0 0 12px rgba(255, 185, 54, 0.34))"
      />
      <Box
        display={{ base: 'block', lg: isCollapsed === false ? 'block' : 'none', xl: isCollapsed ? 'none' : 'block' }}
        minW={ 0 }
      >
        <Text
          as="span"
          display="block"
          fontSize="17px"
          lineHeight="18px"
          fontWeight={ 800 }
          letterSpacing="0"
          bgGradient="linear(to-r, elvor.100, orange.400, elvor.500)"
          bgClip="text"
        >
          Elvor Scan
        </Text>
        <Text as="span" display="block" color="rgba(255, 236, 202, 0.58)" fontSize="10px" lineHeight="12px" fontWeight={ 600 }>
          ELVORSCAN.IO
        </Text>
      </Box>
      <Text
        display={{ base: 'none', lg: isCollapsed === false ? 'none' : 'block', xl: isCollapsed ? 'block' : 'none' }}
        fontSize="9px"
        lineHeight="10px"
        fontWeight={ 900 }
        color="elvor.100"
      >
        ELV
      </Text>
    </Box>
  );
};

export default React.memo(chakra(NetworkLogo));
